<template>
	<li class="tabs-title" :class="{ 'is-active': active }"><a href="#" :aria-selected="active" @click="click">{{ text }}</a></li>
</template>

<script>
	export default {
		props: ['mode', 'text'],
		methods: {
			click: function (e) {
				this.$dispatch('change-mode', e, this.mode);
			}
		},
		computed: {
			active: function () {
				return this.$parent.mode == this.mode;
			}
		}
	}
</script>



/** WEBPACK FOOTER **
 ** Tab.vue?b0cf8462
 **/